import { isObject } from "lodash-es";
import { message } from 'ant-design-vue';
import { $methodKey, argsKey, injectCtxKey, renderCtxKey, invokeCurrentMethodKey } from "./consts";
import { set$MethodsSchema } from "./set$MethodSchema";
import { newFunction } from '@tencent/ui-core/lib/utils/script';
import { METHOD_TYPES } from "../../stateCommon/consts";
import { getFormRuntimeMethod } from "../formMethods/getFormRuntimeMethod";
import WujiTips from "../../../tools/wujiTips";
export function defineMethod(instance, method, options = {}) {
  const {
    renderer
  } = instance.options;
  if (!renderer) {
    throw new Error('defineMethod fail: renderer is null!');
  }
  const getMethod = method.type === METHOD_TYPES.code ? getCodeRuntimeMethod : getFormRuntimeMethod;
  const func = getMethod(instance, method);
  const funcWithCatch = async (...args) => {
    const {
      autoCatch
    } = method;
    let res;
    try {
      method.loading && (instance.loading = true);
      res = await func(...args);
    } catch (error) {
      var _instance$options$sou;
      const sourceId = (_instance$options$sou = instance.options.sourceConfig) === null || _instance$options$sou === void 0 ? void 0 : _instance$options$sou.id;
      const prefix = `数据源方法【${sourceId}.$methods.${method.id}】执行出错 `;
      console.error(prefix, error);
      if (autoCatch) {
        const msg = `${prefix}:${isObject(error) ? error.message : String(error)}`;
        const wujiTips = new WujiTips();
        wujiTips.error({
          content: msg
        });
      } else {
        throw error;
      }
    } finally {
      method.loading && (instance.loading = false);
      if (method.id === 'init') {
        instance.resolveForReady();
      }
    }
    return res;
  };
  if (options.originMethodId && options.originMethodId !== method.id) {
    delete instance[$methodKey][options.originMethodId];
  }
  Object.defineProperty(instance[$methodKey], method.id, {
    value: funcWithCatch,
    enumerable: false,
    writable: true,
    configurable: true
  });
  if (options.setSchema) {
    set$MethodsSchema(instance, method, options);
  }
}
export function getCodeRuntimeMethod(instance, method) {
  const {
    renderer,
    methodExtraCtx = {}
  } = instance.options;
  if (!renderer) {
    throw new Error('defineMethod fail: renderer is null!');
  }
  // const protocol = getSourceProtocolBySource(instance);
  const keys = Object.keys(methodExtraCtx || {}).map(key => `  const ${key}= ${injectCtxKey}.${key};`).join('\n');
  const fnBody = `
return (async function(){
  with(${renderCtxKey}){
    const source = ${injectCtxKey}.source;
    // const protocol = ${injectCtxKey}.protocol;
  ${keys}

    const __method__ = ${method.code}
    return __method__(...${argsKey})
  }
}).call(${renderCtxKey});
 `;
  let fn;
  try {
    fn = newFunction([renderCtxKey, injectCtxKey, argsKey], fnBody);
  } catch (error) {
    var _instance$options$sou2;
    console.error(error);
    message.error(`[${(_instance$options$sou2 = instance.options.sourceConfig) === null || _instance$options$sou2 === void 0 ? void 0 : _instance$options$sou2.id}/${method.id}]代码格式不正确，请确保代码只有一个主体函数`);
    // return;
    fn = () => {
      var _instance$options$sou3;
      const msg = `data.${(_instance$options$sou3 = instance.options.sourceConfig) === null || _instance$options$sou3 === void 0 ? void 0 : _instance$options$sou3.id}.${$methodKey}.${method.id} 方法代码有语法错误，无法执行`;
      message.error(msg);
      console.error(msg);
    };
  }
  const func = async (...args) => {
    const res = await fn(renderer, {
      source: instance,
      ...methodExtraCtx
    }, args);
    return res;
  };
  return func;
}
/**
 * 运行方法的debug代码
 * @param instance
 * @param method
 */
export async function debugMethod(instance, method, ctx = {}) {
  const {
    renderer
  } = instance.options;
  if (!renderer) {
    throw new Error('defineMethod fail: renderer is null!');
  }
  const keys = Object.keys(ctx).map(key => `  const ${key}= ${injectCtxKey}.${key};`).join('\n');
  const fnBody = `
  return (async function(){
    with(${renderCtxKey}){
      const source = ${injectCtxKey}.source;
      const ${invokeCurrentMethodKey} = source.$methods.${method.id};
  ${keys}
      ${method.debugCode}
    }

  }).call(${renderCtxKey});
   `;
  const fn = newFunction([renderCtxKey, injectCtxKey], fnBody);
  try {
    await fn(renderer, {
      source: instance,
      ...ctx
    });
  } catch (error) {
    console.error(error);
  }
}
//# sourceMappingURL=defineMethod.js.map
